export default __webpack_public_path__ + "static/media/unpublished.16794b08.svg";